import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import LockUnlock from "./LockUnlock";
import { useAuth } from "./AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";

// Every trainee login: a Super Admin or Area Admin enters their own 6-digit authenticator code.
export const TraineeApprovalDialog = ({ preAuthToken, onClose }) => {
  const { approveTrainee } = useAuth();
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [accepted, setAccepted] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (code.length !== 6) return;
    setBusy(true);
    const r = await approveTrainee(preAuthToken, code);
    setBusy(false);
    if (r.valid) {
      setAccepted(true);
      setTimeout(() => { r.apply(); toast.success("Welcome to DomiOps Training"); onClose(); navigate("/training"); }, 1050);
    } else {
      toast.error(r.error);
      setCode("");
      if (r.expired) onClose();
    }
  };

  return (
    <Dialog open={!!preAuthToken} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-sm" data-testid="trainee-approval-dialog">
        <DialogHeader className="items-center text-center">
          <LockUnlock size={64} mode={accepted ? "once" : "locked"} />
          <DialogTitle className="text-xl font-semibold uppercase tracking-tight" style={{ fontFamily: 'Inter, sans-serif' }}>
            {accepted ? "Approved" : "Manager approval"}
          </DialogTitle>
          <DialogDescription>
            {accepted ? "Opening Training…" : "Every trainee login needs a Super Admin or Area Admin to enter their 6-digit authenticator code."}
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <input
            data-testid="trainee-approval-code"
            autoFocus inputMode="numeric" maxLength={6} placeholder="6-digit manager code"
            value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
            className="w-full text-center tracking-[0.4em] text-lg font-bold border border-black/[0.15] rounded-lg py-2.5"
          />
          <button type="submit" disabled={busy || code.length !== 6} data-testid="trainee-approval-submit"
            className="w-full py-2.5 rounded-full font-black text-white bg-[#0071e3] disabled:opacity-40">
            {busy ? "Verifying…" : "Approve login"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
